import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import PolicyHoldersService from "../../../services/PolicyHoldersService";
import Spinner from "reactjs-simple-spinner";
import {toast, ToastContainer} from "react-toastify";
import {MenuItem, TextField} from "@material-ui/core";

const EditPolicyHolder = (props) => {
    const [policyHolder, setPolicyHolder] = useState({});
    const [postal_address_street, setPostalAddressStreet] = useState('');
    const [postal_address_suburb, setPostalAddressSuburb] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({})
    const [title, setTitle] = useState('')
    const [first_name, setFName] = useState('')
    const [last_name, setLName] = useState('')
    const [ physical_address_city, setCity] = useState('')
    const [physical_address_street, setStreet] = useState('')
    const [physical_address_suburb, setSuburb] = useState('')
    const [postal_address_city, setPostalAddressCity] = useState('')
    const [email, setEmail] = useState('')
    const [ec_number, setECNumber] = useState('')
    const [mobile, setMobile] = useState('')
    const [work_telephone, setTelephone] = useState('')
    const [salary, setSalary] = useState('')
    const [gender, setGender] = useState('')
    const [smoker_status, setSmokerStatus] = useState('')
    const [date_of_birth, setDob] = useState('')
    const [occupation, setOccupation] = useState('')
    const [id_number, setIdNumber] = useState('')
    const [maritalStatus, setMaritalStatus] = useState('')
    const [editButton, setEditButton] = useState(false)



    useEffect(() => {
        setLoading(true);
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null && false && direct_perm === null && false) {
            setEditButton(false);
        } else if (role_based_perm.length === 0 && direct_perm.length === 0) {
            setEditButton(false);
        } else if (role_based_perm.length > 0) {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
            })
        } else if (direct_perm.length > 0) {
            direct_perm.map((perm, i) => {
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
            })
        }
        const id = JSON.parse(localStorage.getItem('policyHolderId'));
        PolicyHoldersService.getPolicyHolder(id).then(response => {
            console.log(response.data.policyHolder.occupation);
            setPolicyHolder(response.data.policyHolder);
            setFName(response.data.policyHolder.first_name)
            setLName(response.data.policyHolder.last_name)
            setTitle(response.data.policyHolder.title)
            setSuburb(response.data.policyHolder.physical_address_suburb)
            setStreet(response.data.policyHolder.physical_address_street)
            setCity(response.data.policyHolder.physical_address_city)
            setPostalAddressCity(response.data.policyHolder.postal_address_city)
            setPostalAddressSuburb(response.data.policyHolder.postal_address_suburb)
            setPostalAddressStreet(response.data.policyHolder.postal_address_street)
            setOccupation(response.data.policyHolder.occupation)
            setEmail(response.data.policyHolder.email)
            setGender(response.data.policyHolder.gender)
            setDob(response.data.policyHolder.date_of_birth)
            setMobile(response.data.policyHolder.mobile)
            setECNumber(response.data.policyHolder.ec_number)
            setSmokerStatus(response.data.policyHolder.smoker_status)
            setTelephone(response.data.policyHolder.work_telephone)
            setSalary(response.data.policyHolder.salary)
            setIdNumber(response.data.policyHolder.id_number)
            setMaritalStatus(response.data.policyHolder.status);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
        });

    }, []);


    const handleChangeFirstName = (e) => {
        console.log(e.target.value)
        setFName(e.target.value);
    }
    const handleChangeLastName = (e) => {
        console.log(e.target.value)
        setLName(e.target.value);
    }
    const handleChangeMaritalStatus = (e) => {
        console.log(e.target.value)
        setMaritalStatus(e.target.value);
    }
    const handleChangePostalAddressCity = (e) => {
        console.log(e.target.value)
        setPostalAddressCity(e.target.value);
    }
    const handleChangePostalAddressStreet = (e) => {
        console.log(e.target.value)
        setPostalAddressStreet(e.target.value);
    }
    const handleChangePostalAddressSuburb = (e) => {
        console.log(e.target.value)
        setPostalAddressSuburb(e.target.value);
    }
    const handleChangeStreet = (e) => {
        console.log(e.target.value)
        setStreet(e.target.value);
    }
    const handleChangeCity = (e) => {
        console.log(e.target.value)
        setCity(e.target.value);
    }
    const handleChangeSuburb = (e) => {
        console.log(e.target.value)
        setSuburb(e.target.value);
    }
    const handleChangeSalary = (e) => {
        console.log(e.target.value)
        setSalary(e.target.value);
    }
    const handleChangeOccupation = (e) => {
        console.log(e.target.value)
        setOccupation(e.target.value);
    }
    const handleChangeDob = (e) => {
        console.log(e.target.value)
        setDob(e.target.value);
    }
    const handleChangeIdNumber = (e) => {
        console.log(e.target.value)
        setIdNumber(e.target.value);
    }
    const handleChangeGender = (e) => {
        console.log(e.target.value)
        setGender(e.target.value);
    }
    const handleChangeECNumber = (e) => {
        console.log(e.target.value)
        setECNumber(e.target.value);
    }
    const handleChangeTitle = (e) => {
        console.log(e.target.value)
        setTitle(e.target.value);
    }
    const handleChangeTelephone = (e) => {
        console.log(e.target.value)
        setTelephone(e.target.value);
    }
    const handleChangeEmail = (e) => {
        console.log(e.target.value)
        setEmail(e.target.value);
    }
    const handleChangeMobile = (e) => {
        console.log(e.target.value)
        setMobile(e.target.value);
    }
    const handleChangeSmokerStatus = (e) => {
        console.log(e.target.value)
        setSmokerStatus(e.target.value);
    }

    const handleUpdate = (e) => {
        e.preventDefault();
        // setLoading(true);
        setSubmitLoading(true)

         //call update endpoint
         let d = {
             "id": JSON.parse(localStorage.getItem('policyHolderId')),
             "title": title,
             "first_name": first_name,
             "last_name": last_name,
             "date_of_birth": date_of_birth,
             "id_number": id_number,
             "gender": gender,
             "work_telephone": work_telephone,
             "mobile": mobile,
             "email": email,
             "ec_number": ec_number,
             "aggregator_id": policyHolder.aggregator_id,
             "occupation": occupation,
             "physical_address_street": physical_address_street,
             "physical_address_suburb": physical_address_suburb,
             "physical_address_city": physical_address_city,
             "postal_address_street": postal_address_street,
             "postal_address_suburb": postal_address_suburb,
             "postal_address_city": postal_address_city,
             "smoker_status": smoker_status,
             "status": maritalStatus,
             "salary": salary
         }

        // console.log(policyHolder);
        //post data
        PolicyHoldersService.updatePolicyHolder(d)
        .then(res => {
            console.log(res);
            if (res.status === 200 || res.status === 201) {
                toast('Policy Holder Updated Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setSubmitLoading(false);
                console.log(res);
            } else {
                 toast.warning('Operation Failed', {
                     position: "top-center",
                     autoClose: 3000,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                 });
                setSubmitLoading(false);
            }

        })
        .catch(err => {
            toast.warning('Operation Failed', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setSubmitLoading(false);
            console.log(err);
        })
    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                {loading && (
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap p-5 mt-5">
                                <Spinner
                                    size="large"
                                    message="Please Wait..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                )}
                {submitLoading && (
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap p-5 mt-5">
                                <Spinner
                                    size="large"
                                    message="Updating Please Wait..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                )}
                {!loading && !submitLoading && (
                    <div className="content ">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                 &nbsp;|&nbsp;
                                <Link to="/policy-holders"><a href><i className="fa fa-users"/> Leads</a></Link>
                                 &nbsp;|&nbsp;
                                <span
                                    className="text-capitalize"><i
                                    className="fa fa-edit"/> Edit Details For: {title}&nbsp;{first_name}&nbsp;{last_name}</span>
                            </ul>

                            {/*    form */}
                            {editButton ? (
                                <div className="card bg-white p-5">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 className="text-primary"><strong>Edit General Info</strong></h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <h4><b>Title:</b></h4>
                                            <select
                                                className="form-control"
                                                name="title"
                                                // validations={[required]}
                                                onChange={handleChangeTitle}
                                            >
                                                {policyHolder.title !== '' && (
                                                    <option selected={true} value={title}>
                                                        {title}
                                                    </option>
                                                )}
                                                <option value>Select Title</option>
                                                <option value="MR">Mr</option>
                                                <option value="MRS">Mrs</option>
                                                <option value="DR">Dr</option>
                                                <option value="MISS">Miss</option>
                                                <option value="MS">Ms</option>
                                                <option value="PROF">Prof</option>
                                                <option value="ENG">Eng</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>First Name:</b></h4>
                                            <input type="text" className="form-control" value={first_name}
                                                   name="first_name"
                                                   onChange={handleChangeFirstName}/>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Last Name:</b></h4>
                                            <input type="text" name="last_name" onChange={handleChangeLastName}
                                                   className="form-control"
                                                   value={last_name}/>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Marital Status:</b></h4>
                                            <input type="text" name="maritalStatus" onChange={handleChangeMaritalStatus}
                                                   className="form-control"
                                                   value={maritalStatus}/>
                                        </div>
                                        <div className="col-md-4">

                                            <h4><b>Occupation:</b>
                                                <input type="text" name="occupation"
                                                       className="form-control"
                                                       onChange={handleChangeOccupation}
                                                       value={occupation}/>
                                            </h4>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Date of Birth (yyyy-mm-dd):</b>
                                                <input type="text"
                                                       className="form-control"
                                                       onChange={handleChangeDob}
                                                       name="date_of_birth"
                                                       value={date_of_birth}/>
                                            </h4>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Identity Number:</b></h4>
                                            <input type="text"
                                                   className="form-control"
                                                   onChange={handleChangeIdNumber}
                                                   name="id_number" value={id_number}/>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Gender:</b>
                                                <select name="gender" onChange={handleChangeGender}
                                                        className="form-control"
                                                        required>
                                                    {gender !== '' && (
                                                        <option selected={true} value={gender}>
                                                            {gender}
                                                        </option>
                                                    )}
                                                    <option value>Select Gender</option>
                                                    <option value="MALE">MALE</option>
                                                    <option value="FEMALE">FEMALE</option>
                                                </select>
                                            </h4>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>Smokers Status:</b>
                                                <select name="smoker_status" onChange={handleChangeSmokerStatus}
                                                        className="form-control"
                                                        required>
                                                    {smoker_status !== '' && (
                                                        <option selected={true} value={smoker_status}>
                                                            {smoker_status}
                                                        </option>
                                                    )}
                                                    <option value>Select Status</option>
                                                    <option value="UNKNOWN">UNKNOWN</option>
                                                    <option value="CURRENT_SMOKER">CURRENT_SMOKER</option>
                                                    <option value="FORMER_SMOKER">FORMER_SMOKER</option>
                                                    <option value="NEVER_SMOKED">NEVER_SMOKED</option>

                                                </select>
                                            </h4>

                                        </div>
                                    </div>

                                    <div className="row">

                                        <div className="col-md-4">
                                            <h4><b>Salary:</b>
                                                <input type="number" name="salary"
                                                       onChange={handleChangeSalary}
                                                       className="form-control" value={salary}
                                                /></h4>

                                        </div>
                                        <div className="col-md-4">
                                            <h4><b>EC Number:</b> <input type="number"
                                                                         onChange={handleChangeECNumber}
                                                                         name="ec_number"
                                                                         value={ec_number}
                                                                         className="form-control"/></h4>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 className="text-primary"><strong>Edit Contact Details</strong></h4>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><strong>Mobile Number</strong></h4>
                                            <input onChange={handleChangeMobile}
                                                   type="text" name="mobile" value={mobile}
                                                   className="form-control"/>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><strong>Alternative Number</strong></h4>
                                            <input name="work_telephone" value={work_telephone}
                                                   onChange={handleChangeTelephone}
                                                   className="form-control"/>
                                        </div>
                                        <div className="col-md-4">
                                            <h4><strong>Email</strong></h4>
                                            <input type="email" name="email" className="form-control"
                                                   onChange={handleChangeEmail}
                                                   value={email}/>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 className="text-primary"><strong>Edit Address Details</strong></h4>
                                        </div>
                                        <div className="col-md-4">
                                            <h4>Physical Address</h4>
                                            <address>
                                                <span className="font-weight-bold">Street: </span>
                                                <input type='text' value={physical_address_street}
                                                       name="physical_address_street"
                                                       onChange={handleChangeStreet}
                                                       className="form-control ml-4"/>
                                                <br/>
                                                <span className="font-weight-bold">Suburb: </span>
                                                <input type="text" name="physical_address_suburb"
                                                       value={physical_address_suburb}
                                                       onChange={handleChangeSuburb}
                                                       className="form-control ml-4"/>
                                                <br/>
                                                <span className="font-weight-bold"> City: </span>
                                                <TextField
                                                    onChange={handleChangeCity}
                                                    name="physical_address_city"
                                                    select
                                                    fullWidth
                                                    required>
                                                    {physical_address_city !== '' && (
                                                        <MenuItem selected={true} value={physical_address_city}>
                                                            {physical_address_city}
                                                        </MenuItem>
                                                    )}
                                                    <MenuItem value disabled={true}>Select City</MenuItem>
                                                    <MenuItem value="Arcturus">Arcturus</MenuItem>
                                                    <MenuItem value="Banket">Banket</MenuItem>
                                                    <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                                    <MenuItem value="Bindura">Bindura</MenuItem>
                                                    <MenuItem value="Buhera">Buhera</MenuItem>
                                                    <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                                    <MenuItem value="Chegutu">Chegutu</MenuItem>
                                                    <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                                    <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                                    <MenuItem value="Chipinge">Chipinge</MenuItem>
                                                    <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                                    <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                                    <MenuItem value="Chivhu">Chivhu</MenuItem>
                                                    <MenuItem value="Darwendale">Darwendale</MenuItem>
                                                    <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                                    <MenuItem value="Guruve">Guruve</MenuItem>
                                                    <MenuItem value="Gwanda">Gwanda</MenuItem>
                                                    <MenuItem value="Gweru">Gweru</MenuItem>
                                                    <MenuItem value="Harare">Harare</MenuItem>
                                                    <MenuItem value="Hwange">Hwange</MenuItem>
                                                    <MenuItem value="Kadoma">Kadoma</MenuItem>
                                                    <MenuItem value="Kariba">Kariba</MenuItem>
                                                    <MenuItem value="Karoi">Karoi</MenuItem>
                                                    <MenuItem value="Kezi">Kezi</MenuItem>
                                                    <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                                    <MenuItem value="Lupane">Lupane</MenuItem>
                                                    <MenuItem value="Marondera">Marondera</MenuItem>
                                                    <MenuItem value="Masvingo">Masvingo</MenuItem>
                                                    <MenuItem value="Mazoe">Mazoe</MenuItem>
                                                    <MenuItem value="Mhangura">Mhangura</MenuItem>
                                                    <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                                    <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                                    <MenuItem value="Murehwa">Murehwa</MenuItem>
                                                    <MenuItem value="Mutare">Mutare</MenuItem>
                                                    <MenuItem value="Mutoko">Mutoko</MenuItem>
                                                    <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                                    <MenuItem value="Norton">Norton</MenuItem>
                                                    <MenuItem value="Nyanga">Nyanga</MenuItem>
                                                    <MenuItem value="Plumtree">Plumtree</MenuItem>
                                                    <MenuItem value="Redcliff">Redcliff</MenuItem>
                                                    <MenuItem value="Rusape">Rusape</MenuItem>
                                                    <MenuItem value="Ruwa">Ruwa</MenuItem>
                                                    <MenuItem value="Sakubva">Sakubva</MenuItem>
                                                    <MenuItem value="Shamva">Shamva</MenuItem>
                                                    <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                                    <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                                    <MenuItem value="Zvishavane">Zvishavane</MenuItem>

                                                </TextField>
                                            </address>
                                        </div>
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4">
                                            <h4>Postal Address</h4>
                                            <address>
                                                <span className="font-weight-bold">Street:</span>
                                                <input type="text" name="postal_address_street"
                                                       onChange={handleChangePostalAddressStreet}
                                                       value={postal_address_street}
                                                       className="form-control ml-4"/><br/>
                                                <span className="font-weight-bold">Suburb: </span>
                                                <input type="text" name="postal_address_suburb"
                                                       onChange={handleChangePostalAddressSuburb}
                                                       value={postal_address_suburb}
                                                       className="form-control ml-4"/><br/>
                                                <span className="font-weight-bold">City: </span>
                                                <TextField
                                                    onChange={handleChangePostalAddressCity}
                                                    name="postal_address_city"
                                                    select
                                                    fullWidth
                                                    required>
                                                    {postal_address_city !== '' && (
                                                        <MenuItem selected={true} value={postal_address_city}>
                                                            {postal_address_city}
                                                        </MenuItem>
                                                    )}
                                                    <MenuItem value disabled={true}>Select City</MenuItem>
                                                    <MenuItem value="Arcturus">Arcturus</MenuItem>
                                                    <MenuItem value="Banket">Banket</MenuItem>
                                                    <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                                    <MenuItem value="Bindura">Bindura</MenuItem>
                                                    <MenuItem value="Buhera">Buhera</MenuItem>
                                                    <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                                    <MenuItem value="Chegutu">Chegutu</MenuItem>
                                                    <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                                    <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                                    <MenuItem value="Chipinge">Chipinge</MenuItem>
                                                    <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                                    <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                                    <MenuItem value="Chivhu">Chivhu</MenuItem>
                                                    <MenuItem value="Darwendale">Darwendale</MenuItem>
                                                    <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                                    <MenuItem value="Guruve">Guruve</MenuItem>
                                                    <MenuItem value="Gwanda">Gwanda</MenuItem>
                                                    <MenuItem value="Gweru">Gweru</MenuItem>
                                                    <MenuItem value="Harare">Harare</MenuItem>
                                                    <MenuItem value="Hwange">Hwange</MenuItem>
                                                    <MenuItem value="Kadoma">Kadoma</MenuItem>
                                                    <MenuItem value="Kariba">Kariba</MenuItem>
                                                    <MenuItem value="Karoi">Karoi</MenuItem>
                                                    <MenuItem value="Kezi">Kezi</MenuItem>
                                                    <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                                    <MenuItem value="Lupane">Lupane</MenuItem>
                                                    <MenuItem value="Marondera">Marondera</MenuItem>
                                                    <MenuItem value="Masvingo">Masvingo</MenuItem>
                                                    <MenuItem value="Mazoe">Mazoe</MenuItem>
                                                    <MenuItem value="Mhangura">Mhangura</MenuItem>
                                                    <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                                    <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                                    <MenuItem value="Murehwa">Murehwa</MenuItem>
                                                    <MenuItem value="Mutare">Mutare</MenuItem>
                                                    <MenuItem value="Mutoko">Mutoko</MenuItem>
                                                    <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                                    <MenuItem value="Norton">Norton</MenuItem>
                                                    <MenuItem value="Nyanga">Nyanga</MenuItem>
                                                    <MenuItem value="Plumtree">Plumtree</MenuItem>
                                                    <MenuItem value="Redcliff">Redcliff</MenuItem>
                                                    <MenuItem value="Rusape">Rusape</MenuItem>
                                                    <MenuItem value="Ruwa">Ruwa</MenuItem>
                                                    <MenuItem value="Sakubva">Sakubva</MenuItem>
                                                    <MenuItem value="Shamva">Shamva</MenuItem>
                                                    <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                                    <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                                    <MenuItem value="Zvishavane">Zvishavane</MenuItem>
                                                </TextField>
                                            </address>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3">
                                            <button onClick={handleUpdate}
                                                    className="btn btn-sm btn-primary rounded-pill">
                                                <i className="fa fa-refresh"/>&nbsp; Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="card bg-white p-5">
                                    <div className="row mt-5">
                                        <div className="col-md-12">
                                            <h4 className="text-center text-danger"><strong>Not Authorized To Perform
                                                This Action</strong></h4>
                                            <h4 className="text-secondary text-center"><strong>If this is an error,
                                                kindly contact the System Administrator</strong></h4>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EditPolicyHolder;
